<template>
    <div>
        <!--调拨报表-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间" style="margin-right: 200px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>

                    </Form>
                </Col>
            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">
        </Table>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                columns: [
                    {title: '姓名', key: 'adminName',align:'center'},
                    {title: '店铺', key: 'shopName',align:'center' },
                    {title: '销售数据(元)', key: 'lpriceTotal' ,align:'center' },
                    {title: '毛利统计(元)', key: 'benefitTotal',align:'center' },
                ],
                data: [],
                page:{
                    total:0,
                    page:1,
                    rows:12
                },
                loadingTable:true
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(0)
            this.valuedate[1] = this.nowTime

            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if( !PermisCode.includes('94') ){
                this.columns= [
                    {title: '姓名', key: 'adminName',align:'center'},
                    {title: '店铺', key: 'shopName',align:'center' },
                    {title: '销售数据(元)', key: 'lpriceTotal' ,align:'center' },
                ]
            }

            this.getPerformanceList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
        },

        methods: {
            getPerformanceList(beantime,endtime,page,rows){
                this.loadingTable=true
                this.$Api.getPerformanceList({
                    cid: this.cid,
                    sid:this.sid,
                    beantime: beantime,
                    endtime: endtime,
                    page: page,
                    rows: rows,
                    status: "0,2" //业务类型  0增销售单/1销售撤销单2退换货销售单
                }).then(res => {
                    if(res.code==200){
                       this.page.total = res.count
                        this.data = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.loadingTable=false
                }).catch(function (err) {
                    this.$Message.warning(err.msg);
                    this.loadingTable=false
                });
            },

            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.getPerformanceList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            },
            onGongPageTotal(num){
                this.getPerformanceList(this.valuedate[0],this.valuedate[1],num,this.page.rows)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .tableFirst{
        color: #ff5e5e;
    }
</style>